<section class="main-content">
  <markdown class="page-markdown" [data]="'offersPage.content' | translate"></markdown>
  <div class="preview">
    <placeme-offer-group-card
      *ngFor="let group of offerGroups$ | async; index as i"
      [offerGroup]="group"
      class="preview__offer"
    ></placeme-offer-group-card>
  </div>
  <a placeme-button [routerLink]="['/', 'offres'] | localize">{{ 'homePage.offers.ctaLabel' | translate }}</a>
</section>
